import { ChallengePrizeType } from './ChallengePrize';

export const OLD_CHALLENGE_PRIZES: ChallengePrizeType[] = [
    {
        title: '1 место',
        text: '250 000 рублей',
        image: 'https://avatars.mds.yandex.net/get-lpc/14837328/c24898a1-e6df-48ef-8ff3-392722f2d8cd/width_1280_q90',
    },
    {
        title: '2 место',
        text: '150 000 рублей',
        image: 'https://avatars.mds.yandex.net/get-lpc/16904900/e0f1c9a4-1721-47d6-8f0b-484ba79a2e14/width_1280_q90',
    },
    {
        title: '3 место',
        text: '50 000 рублей\nи Яндекс Станция',
        image: 'https://avatars.mds.yandex.net/get-lpc/16904900/90fb2f00-d166-455b-96f8-8d7849071a6f/width_1280_q90',
    },
];

const CHALLENGE_PRIZES: ChallengePrizeType[] = [
    {
        title: '1 место',
        text: '100 000 рублей',
        image: 'https://avatars.mds.yandex.net/get-lpc/14837328/c24898a1-e6df-48ef-8ff3-392722f2d8cd/width_1280_q90',
    },
    {
        title: '2 место',
        text: '50 000 рублей',
        image: 'https://avatars.mds.yandex.net/get-lpc/16904900/e0f1c9a4-1721-47d6-8f0b-484ba79a2e14/width_1280_q90',
    },
    {
        title: '3 место',
        text: '30 000 рублей',
        image: 'https://avatars.mds.yandex.net/get-lpc/17800094/3bbac947-6bc5-40f2-aedd-50b4e3dd2bce/width_1280_q90',
    },
    {
        title: 'c 4 по 10 место',
        text: '15 000 рублей',
        image: 'https://avatars.mds.yandex.net/get-lpc/16904900/92ba8fe5-190f-4430-8a9f-3d23bc5422e9/width_1280_q90',
    },
];

export const getChallengePrizes = (challengeTitle: string): ChallengePrizeType[] => {
    const isNewChallengePrizes = challengeTitle === 'Пояснить за науку';

    return isNewChallengePrizes ? CHALLENGE_PRIZES : OLD_CHALLENGE_PRIZES;
};
